import React from 'react';
import omit from 'lodash/omit';
import { ODMobileOnlyToggleMenuButton } from './menu/utils/ODMobileOnlyToggleMenuButton';
import { useRandomDefaultValue } from '../../hooks';
import { gnbMobileOnlyToggleMenuButtonIsOpenAtomFamily } from './gnbCommon';
import { useRecoilValue } from 'recoil';
import { ODGNBLogo } from './logo/ODGNBLogo';
import { ODAppBarThemeType } from '../../interfaces/gnbInterfaces';
import { ODGNBMenu } from './menu/ODGNBMenu';
import { ODGNBProvider } from './ODGNBProvider';
import { useGlobalContext } from '../global';
import classNames from 'classnames';
export var ODGlobalNavBar = function (props) {
    var def = props.def, className = props.className;
    var _globalKey = def.globalKey, logo = def.logo, menu = def.menu, position = def.position, width = def.width, height = def.height, bgColor = def.bgColor, theme = def.theme;
    var themeType = theme.type;
    var convertThemeString = useGlobalContext().convertThemeString;
    var globalKey = useRandomDefaultValue(_globalKey);
    var mobileOpen = useRecoilValue(gnbMobileOnlyToggleMenuButtonIsOpenAtomFamily(globalKey));
    var isCui = themeType === ODAppBarThemeType.CoreUILike;
    var cuiTheme = theme;
    var outerStyle = omit({
        width: position === 'side' && height !== undefined ? convertThemeString(width) : undefined,
        borderBottom: isCui ? convertThemeString(cuiTheme.borderBottom) : undefined,
    });
    var innerStyle = omit({
        minHeight: position === 'top' && height !== undefined ? convertThemeString(height) : undefined,
        backgroundColor: convertThemeString(bgColor),
        padding: isCui ? 0 : undefined,
        paddingRight: isCui ? convertThemeString(cuiTheme.paddingRight) : undefined,
    });
    var mobileWrapperStyle = omit({
        padding: isCui ? 0 : undefined,
        paddingLeft: isCui ? convertThemeString(cuiTheme.paddingLeft) : undefined,
        paddingRight: isCui ? convertThemeString(cuiTheme.paddingRight) : undefined,
    });
    // const mobileWrapperCN = classNames('od-gnb-mobile-wrapper', { 'md:hidden': !logo })
    return (React.createElement(ODGNBProvider, { def: def },
        React.createElement("div", { className: classNames('od-gnb-outer', className), "od-theme": themeType, "od-position": position, style: outerStyle },
            React.createElement("div", { className: classNames('od-gnb-inner'), "od-theme": themeType, "od-position": position, style: innerStyle },
                React.createElement("div", { className: classNames('od-gnb-mobile-wrapper'), style: mobileWrapperStyle, "od-theme": themeType, "od-position": position, "od-has-logo": (!!logo).toString() },
                    logo && React.createElement(ODGNBLogo, { def: logo }),
                    React.createElement(ODMobileOnlyToggleMenuButton, { globalKey: globalKey, position: position })),
                React.createElement("nav", { className: classNames('od-gnb-nav'), "od-theme": themeType, "od-position": position, "od-open": mobileOpen.toString() },
                    React.createElement(ODGNBMenu, { def: menu, style: position }))))));
};
//# sourceMappingURL=ODGlobalNavBar.js.map